// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UpgradeSuccess_wrapper__3PFIw","content":"UpgradeSuccess_content__1-NYs"};